import React from 'react';
/**
 * Currently disabled (returns null). Kept as a no-op component so existing
 * imports in LandingPage continue to work without attaching an unused
 * scroll listener that ran on every scroll event.
 */
export function StickyCTA() {
  return null;
}